import React from 'react';
import styles from './textarea.module.scss';
import classnames from 'classnames';

const TextArea = React.memo(({
  error = null,
  touched,
  wrapperClass = null,
  inputStyle = 'user',
  className = {},
  ...props
}) => {
  return (
    <div className={classnames(styles.root, wrapperClass)}>
      <textarea className={classnames(styles.input, styles[inputStyle], className)} {...props} />
      <span className={styles.error}>{error}</span>
    </div>
  );
});

export { TextArea };
